<template>
  <div v-if="value" class="overlay">
    <div class="spinner">
      <!-- Puedes usar un ícono de Vuetify -->
      <!-- <v-icon color="white" size="64">mdi-cached</v-icon> -->

      <!-- O una imagen personalizada -->
      <!-- <img src="@/assets/logo.svg" alt="loading" class="icon-image"> -->
      <v-progress-circular indeterminate color="primary"></v-progress-circular>

      <p class="text"> Un momento...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomLoading',
  props: {
    value: Boolean
  }
}
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.spinner {
  text-align: center;
  color: white;
}

.icon-image {
  width: 80px;
  height: 80px;
  animation: spin 1.8s linear infinite;
  filter: drop-shadow(0 0 5px white);
}

.text {
  margin-top: 12px;
  font-size: 1.2em;
}

/* Si usas imagen, puedes animarla */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
